import { useSubtitleFilters } from "app/custom-hooks/useSubtitleFilters";
import { useDisplayAdvertiserPublisherDataAndParams } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useDisplayAdvertiserPublisherDataAndParams";
import { GranularitySwitcherEnum } from "app/pages/industry-analysis/category-share/CategoryShareGraph/CategoryShareGraphTypes";
import DurationService from "app/services/DurationService";

import { EDeviceType, webSourceToDeviceForApi } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import { useWebSourceSubtitleFilter } from "../hooks/useWebSourceSubtitleFilter";
import type { AdIntelligenceController } from "../shared/types/types";

import { PerformanceOverTimeChart } from "./PerformanceOverTimeChart";
import { usePerformanceOverTimeData } from "./hooks/usePerformanceOverTimeData";
import type { DomainPerformanceData } from "./types";

interface IPerformanceOverTimeGraphProps {
    isPreview?: boolean;
    controller?: AdIntelligenceController;
    defaultGranularity?: GranularitySwitcherEnum;
    hideGranularityFilter?: boolean;
}

export const PerformanceOverTimeGraph = ({
    isPreview = false,
    controller = "advertiser",
    defaultGranularity = GranularitySwitcherEnum.WEEKLY,
    hideGranularityFilter = false,
}: IPerformanceOverTimeGraphProps) => {
    const params = useDisplayAdvertiserPublisherDataAndParams();
    const { from, to, isWindow } = DurationService.getDurationData(params.duration).forAPI;

    const subtitleFilters = useSubtitleFilters("date", "country");
    const webSourceSubtitleFilter = useWebSourceSubtitleFilter(EDeviceType.TOTAL);

    const { data, isLoading, isFetching, isError } = usePerformanceOverTimeData(params, from, to, isWindow, controller);

    const domainData = data?.data?.[params.key.split(",")[0]] as DomainPerformanceData | undefined;
    const deviceKey = webSourceToDeviceForApi[EDeviceType.TOTAL].toLowerCase() as keyof DomainPerformanceData;

    return (
        <PerformanceOverTimeChart
            performanceData={domainData?.[deviceKey]}
            hasAdIntelMetrics={data?.hasAdIntelMetrics}
            isLoading={isLoading || isFetching}
            isError={isError}
            subtitleFilters={[...subtitleFilters, webSourceSubtitleFilter]}
            isPreview={isPreview}
            controller={controller}
            defaultGranularity={defaultGranularity}
            hideGranularityFilter={hideGranularityFilter}
        />
    );
};
